module.exports = __webpack_public_path__ + "media/yi4.9abfbce4.mp4";